<!-- 巨量引擎2.0项目 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="jl-screen-box">
				<a-dropdown-button @click="handleButtonClick">
				    批量操作
					<a-menu slot="overlay" @click="handleMenuClick">
						<!-- <a-menu-item key="1"> <a-icon type="align-right" />开启</a-menu-item>
						<a-menu-item key="2"> <a-icon type="align-right" />暂停</a-menu-item>
						<a-menu-item key="3"> <a-icon type="user-delete" />删除</a-menu-item> -->
						<!-- <a-menu-item key="5"> <a-icon type="align-right" />修改回传参数</a-menu-item> -->
					</a-menu>
				</a-dropdown-button>
			</div>
			
			<div class="jl-screen-box">
				<a-button @click="custtom_visible = true" icon="unordered-list" >自定义列</a-button>
			</div>
			
			<div class="jl-screen-box">
				<a-dropdown-button @click="handleButtonClick">
				    {{type_button_text}}
					<a-menu slot="overlay" @click="handleMenuClickB">
						<a-menu-item key="1"> <a-icon type="align-right" />全部</a-menu-item>
						<a-menu-item key="2"> <a-icon type="align-right" />只看有消耗</a-menu-item>
						<a-menu-item key="3"> <a-icon type="align-right" />只看有展示</a-menu-item>
					</a-menu>
				</a-dropdown-button>
			</div>
			
			<!-- <div style="display: flex;align-items: center;padding-right: 10px;"> -->
				<div class="jl-screen-box">
					<a-range-picker style="width:200px;" @change="onChangeDate" :allowClear="false"
					:locale="locale" 
					:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
				</div>
				
				<div class="jl-screen-box">
					<jlAdvSelect ref="getAdvSelect" @handle-change="handleChangeB"></jlAdvSelect>
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_adv_name" allowClear placeholder="请输入广告账户名称" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_advertiser_id" allowClear placeholder="请输入广告账户id" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_project_name" allowClear placeholder="请输入项目名称" style="width: 200px;"  />
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_project_id" allowClear placeholder="请输入项目id" style="width: 200px;"  />
				</div>
				
				<div v-if="Object.keys(personChargeList).length > 0" class="jl-screen-box">
					<a-select
						mode="multiple" 
						style="min-width: 135px;max-width: 390px;"
						placeholder="请选择投手"
						@change="handleChangeA"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						:value="r_admin_id"
						allowClear
						showSearch
					  >
						<a-select-option value="-1">未设置</a-select-option>
						<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<!-- <div class="jl-screen-box">
					<a-select
						style="min-width: 150px;max-width: 390px;"
						placeholder="请选择书城频道"
						@change="handleChangeX"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option v-for="(item,index) in filterData.book_type.list" :key="item.key" :value="item.key">
						  {{item.value}}
						</a-select-option>
						<a-select-option value="-1">未设置</a-select-option>
					</a-select>
				</div> -->
				
				<!-- <div class="jl-screen-box">
					<a-select
						style="min-width: 150px;"
						placeholder="请选择书城形式"
						@change="handleChangeY"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option value="-1">未设置</a-select-option>
						<a-select-option value="1">加粉</a-select-option>
						<a-select-option value="2">快应用</a-select-option>
					</a-select>
				</div> -->
				
				<!-- <div class="jl-screen-box">
					<a-select
						style="min-width: 160px"
						placeholder="请选择书城渠道"
						@change="handleChangeZ"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option value="-1">未设置</a-select-option>
						<a-select-option v-for="(item,index) in filterData.channel_id.list" :key="item.key" :value="item.key">
						  {{item.value}}
						</a-select-option>
					</a-select>
				</div> -->
				
				<div class="jl-screen-box">
					<a-select
						style="min-width: 110px"
						placeholder="操作状态"
						@change="handleChangeG"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option v-for="(value,key) in conditionSelect.opt_status" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<a-button @click="searchButton('button')" :loading="search_button_loading" class="jl-screen-box" type="primary" icon="search">搜索</a-button>
				
			<!-- </div> -->
		</div>
	</div>
	</div>
	
	<div style="">
		<JLprojectTable @table-th-click="tableThClick" :rableTitle="rableTitle" 
		:tableShowData="tableShowData" :tableSumData="tableSumData" 
		:table_scroll_width="table_scroll_width" 
		:indeterminate="indeterminate" :checkAll="checkAll" :table_null_width="table_null_width" 
		@click-All-Checkbox="onCheckAllChange" @click-Checkbox="onChangeCheckbox"
		@status-Checkbox="statusCheckbox"></JLprojectTable>
	</div>
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	
	<!-- 批量删除 -->
	<a-modal :visible="dl_modal" title="确认要删除这些吗？" okType="danger" width="700px"
	  okText="删除" cancelText="取消"
	  @ok="dlOk" @cancel="dlCancel" :confirmLoading="dl_loading">
	    <div style="">
			<div style="margin-bottom: 10px;">已选的删除项（广告计划名称）：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 15px;" class="">
					<div style="width: 80px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 195px;">{{item.plan_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	
	<!-- 自定义列 -->
	<a-modal v-model="custtom_visible" width="830px" title="设置自定义列"  @ok="customTd" @cancel="customTd" okText="确认" cancelText="取消" >
	    <div style="max-height:500px;overflow-y: overlay;">
			<template  v-for="(d_tem,d_ndex) in customCheckboxData">
				<div class="custom-title">
					<a-checkbox @change="checkboxCustom($event,d_tem)"
					:checked="d_tem.custom_checkbox" style="margin-right: 5px;margin-bottom:7px;"></a-checkbox>
					{{d_tem.label}}
				</div>
				<div class="custom-cell-box">
					<template v-for="(item,index) in rableTitle">
						<div v-if="(d_tem.showTitle.indexOf(item.type) > -1)" 
						:key="item.type" style="width:240px;">
							<a-checkbox @change="onChangeSJ($event,index,d_tem)"
							:checked="item.show_control" style="margin-right: 5px;margin-bottom:7px;">
								{{item.title}}
							</a-checkbox>
						</div>
					</template>
				</div>
			</template>
			
	    </div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { JLpjList , putDataMenu, JLjhEditStatus, putUserList, JLjhPlanDate, JLjhReportConfig, JLjhPlReportConfig, JLjhExport } from '@/request/api'
import JLprojectTable from '@/components/JLtable/JLprojectTable.vue'
import jlAdvSelect from './components/jlAdvSelect.vue'
export default {
	name: 'JLproject_',
	components: {
		JLprojectTable, jlAdvSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			s_limit: 100,
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"项目名称",width:110, sort_status:0, type:"name", text_right: false,sort_:90,sort_control: false, show_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"操作",width:100, sort_status:0, type:"cz", text_right: false,sort_:88,sort_control: false, show_control: true,},
				
				
				{title:"消耗",width:85, sort_status:0, type:"stat_cost", text_right: true,sort_:87,sort_control: true, show_control: true,},
				{title:"展示数",width:85, sort_status:0, type:"show_cnt", text_right: true,sort_:86,sort_control: true, show_control: false,},
				{title:"ecpm",width:80, sort_status:0, type:"avg_show_cost", text_right: true,sort_:85,sort_control: true, show_control: false,},
				{title:"点击数",width:80, sort_status:0, type:"click_cnt", text_right: true,sort_:39,sort_control: true, show_control: false,},
				{title:"平均点击单价",width:80, sort_status:0, type:"avg_click_cost", text_right: true,sort_:38,sort_control: true, show_control: false,},
				{title:"点击率",width:80, sort_status:0, type:"ctr", text_right: true,sort_:37,sort_control: true, show_control: false,},
				{title:"激活数",width:80, sort_status:0, type:"active", text_right: true,sort_:39,sort_control: true, show_control: true,},
				{title:"激活成本",width:85, sort_status:0, type:"active_cost", text_right: true,sort_:39,sort_control: true, show_control: true,},
				{title:"转化数",width:80, sort_status:0, type:"convert", text_right: true,sort_:36,sort_control: true, show_control: true,},
				{title:"平均转化成本",width:80, sort_status:0, type:"convert_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"转化率",width:80, sort_status:0, type:"convert_rate", text_right: true,sort_:35,sort_control: true, show_control: false,},
				
				{title:"当天总充值金额",width:85, sort_status:0, type:"eff_total_pay_money", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天分成金额",width:85, sort_status:0, type:"eff_total_left_money", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充分成金额",width:85, sort_status:0, type:"eff_total_left_money_fisrt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天总ROI",width:70, sort_status:0, type:"eff_roi", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充ROI",width:80, sort_status:0, type:"eff_roi_first", text_right: true,sort_:35,sort_control: true, show_control: true,},
				
				{title:"落地页跳转数",width:80, sort_status:0, type:"user_click", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"跳转成本",width:80, sort_status:0, type:"lp_price", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天订单笔数",width:80, sort_status:0, type:"eff_total_order_cnt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天充值用户数",width:90, sort_status:0, type:"eff_total_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天充值用户成本",width:90, sort_status:0, type:"eff_total_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"ARPU",width:80, sort_status:0, type:"arpu", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户数",width:80, sort_status:0, type:"eff_report_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传付费用户成本",width:100, sort_status:0, type:"eff_report_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				
				{title:"项目ID",width:150, sort_status:0, type:"project_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"账户名称",width:120, sort_status:0, type:"adv_name", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"账户ID",width:130, sort_status:0, type:"advertiser_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"创建时间",width:140, sort_status:0, type:"project_create_time", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"更新时间",width:140, sort_status:0, type:"project_modify_time", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"投手",width:120, sort_status:0, type:"admin_list", text_right: false,sort_:35,sort_control: false, show_control: true,},
			],
			tableShowData: [], // 显示表格内容
			tableSumData: {}, // 总计

			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_sort_field: "", // 排序参数
			r_sort_type: "", // 排序类型
			r_admin_id: [], // 选择投手
			r_adv_id: [], // 选择的广告账户
			
			r_opt_status: "", // 操作状态
			r_export: "", // 是否导出，为1表示导出
			r_book_type: "", // 书城频道
			r_book_fun: "", // 书城形式
			r_channel_id: "", // 书城渠道
			
			r_adv_name: "", // 广告账户名称模糊搜索
			r_project_name: "", // 项目名称搜索
			r_project_id: "", // 项目id搜索(长id) 
			r_advertiser_id: "", // 广告账户id搜索(长id)
			
			filterData: {
				op_id:{
					list: [{}],
				},
				channel_id:{
					list: [{}],
				},
				book_type: {
					list: [{}],
				}
			}, 
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 批量删除弹窗
			dl_modal: false,
			dl_loading: false,
			
			personChargeList: {}, // 投手
			conditionSelect: {
				opt_status: {
					ENABLE: "启用",
					DISABLE: "暂停"
				},
				status: {},
			} , // 搜索条件（广告状态、操作状态）
			
			type_button_text: "全部", // 只看有消耗/只看有展示的按钮文案
			type_button_key: '1', // 当前选中状态的key，避免点击同样的选项重复请求。默认是全部
			have_cost: "", // 只看有消耗
			have_show: "", // 只看有展示
			
			role_control: [], // 用户权限控制
			
			pjSelectData: [], // 巨量项目下拉数据
			
			// 自定义列
			custtom_visible: false, // 自定义列弹窗
			customCheckboxData: [ // 自定义列
				// {
				// 	label: "基础信息：",
				// 	showTitle:['status'],
				// 	custom_checkbox: true,
				// 	type:"jc"
				// },
				{
					label: "平台数据项：",
					showTitle:['stat_cost','show_cnt','avg_show_cost','click_cnt','avg_click_cost','ctr','active','active_cost','convert','convert_cost','convert_rate'],
					custom_checkbox: false,
					type:"ty"
				},
				{
					label: "飞碟统计数据项：",
					showTitle:["eff_total_pay_money","eff_total_left_money","eff_total_left_money_fisrt","eff_roi","eff_roi_first","user_click","lp_price","eff_total_order_cnt","eff_total_pay_user_cnt","eff_total_pay_user_cost","arpu","eff_report_pay_user_cnt","eff_report_pay_user_cost",],
					custom_checkbox: false,
					type:"sjx"
				},
				{
					label: "其他信息：",
					showTitle:['project_id','adv_name','advertiser_id','project_create_time','project_modify_time','admin_list'],
					custom_checkbox: true,
					type:"qt"
				},
			],
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		function jsTable(){
			let nn = 0
			that.rableTitle.forEach((res,index)=>{
				if(res.show_control){
					nn = nn + res.width
				}
			})
			that.table_scroll_width = nn + 30 + 30
			if(that.table_scroll_width >= that.body_width){ that.table_null_width = that.body_width - 60 }
			else { that.table_null_width = that.table_scroll_width - 60 }
			
			that.$nextTick(()=>{
				// 给母页面的tab传递粘性定位用的参数
				that.$bus.$emit("stickyData", that.table_scroll_width);
			})
		}
		
		// 有自定义列缓存
		if(localStorage.getItem("table_custtom_JLproject")){
			
			try{
				let s_title = JSON.parse(localStorage.getItem("table_custtom_JLproject"))
				that.rableTitle.forEach(res=>{
					s_title.forEach(re_z=>{
						if(res.type == re_z.type){
							res.show_control = re_z.show_control
						}
					})
				})
				// 重新计算表格宽度
				that.computeTableWidth()
				
			}catch(e){
				jsTable()
			}
		}
		else { // 没自定义列缓存
			// console.log("没自定义列缓存");
			jsTable()
		}
		
		
		// 修改母页面的tab选中状态
		// that.$nextTick(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// })
		
		// 获取账户下拉
		that.$refs.getAdvSelect.getSelectData()
		console.log("this.$route.params",this.$route.params)
		// 接收从计划页面传过来的参数
		if(this.$route.params){
			if(this.$route.params.router_adv_id){ // 广告账户
				this.r_adv_id = this.$route.params.router_adv_id
			}
			
			if(this.$route.params.jump_type == "pl"){
				this.r_adv_id = JSON.parse(sessionStorage.getItem('pl_adv_id'))
				that.$nextTick(()=>{
					that.$refs.getAdvSelect.setValue(that.r_adv_id)
				})
			}
		}
		if(this.$route.query){ 
			// 鼠标右键新窗口打开过来的
			if(this.$route.query.router_adv_id){ // 广告账户
				this.r_adv_id = this.$route.query.router_adv_id
				that.$nextTick(()=>{
					that.$refs.getAdvSelect.setValue(Number(this.r_adv_id))
				})
			}
		}
		
		// 获取角色权限
		that.role_control = JSON.parse(localStorage.getItem("role_limits"))
		
		that.endTime = this.$getThisDay()
		that.startTime = this.$getThisDay() // 默认只获取当天
		
		// 接收从计划页面传过来的参数
		if(this.$route.params){
			if(this.$route.params.jump_id){
				this.r_adv_id = this.$route.params.jump_id
				
			}
		}
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
		})
		
		// 负责人
		putUserList().then(res=>{
			console.log("负责人",res);
			that.personChargeList = res.data.data.list
		})
		
		// 搜索
		that.searchButton()
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		
		handleChangeA(e){ // 选择投手
			console.log(e);
			// 未设置的选项与其他选项不可以同时选，所以这里要加限制
			if(e.length > 1 && e.indexOf('-1') > -1){
				this.$message.warning('未设置与其他选项不能同时选择');
			}
			else {
				this.r_admin_id = e
			}
		},
		handleChangeB(e){ // 选择广告账户
			// console.log(e);
			this.r_adv_id = e
		},
		
		handleChangeG(e){ // 操作状态
			// console.log(e);
			this.r_opt_status = e
		},
		handleChangeX(e){ // 书城频道
			this.r_book_type = e
		},
		handleChangeY(e){ // 书城形式
			this.r_book_fun = e
		},
		handleChangeZ(e){ // 书城渠道
			this.r_channel_id = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
				
				// 这个页面经常需要通过消费的排序或其他排序来看数据，所以这里清空的话，每次搜索就要重新点排序，麻烦，干脆注释
				// 排序的状态重置
				// that.r_sort_field = ''
				// that.r_sort_type = ''
				// that.rableTitle.forEach(res=>{
				// 	res.sort_status = 0 // 排序的状态重置
				// })
			}
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				start_time: that.startTime.replace(/-/g, ''),
				end_time: that.endTime.replace(/-/g, ''),
				advertiser_id: that.r_adv_id, // 选择的广告账户。广告账户adv_id数组
				
			}
			if(that.r_book_type){ r_data.book_type = that.r_book_type } // 书城频道
			if(that.r_book_fun){ r_data.book_fun = that.r_book_fun } // 书城形式
			if(that.r_channel_id){ r_data.channel_id = that.r_channel_id } // 书城渠道
			if(that.r_adv_name){ r_data.adv_name = that.r_adv_name } // 广告账户名称搜索
			if(that.r_project_name){ r_data.project_name = that.r_project_name } // 项目名称搜索
			if(that.r_project_id){ r_data.project_id = that.r_project_id } // 项目id搜索(长id)
			if(that.r_advertiser_id){ r_data.advertiser_id = that.r_advertiser_id } // 广告账户id搜索(长id)
			
			// 超级管理、投放管理可以有 投手
			if(Object.keys(that.personChargeList).length > 0){
				r_data.admin_id = that.r_admin_id // 选择投手
			}
			if(that.r_opt_status){ // 操作状态
				r_data.opt_status = that.r_opt_status
			}
			
			// 如有排序字段就加上
			if(that.r_sort_field){ 
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			// 只看有消耗/只看有展示 按钮
			if(that.have_cost == "1"){ // 消耗
				r_data.have_cost = "1"
			}
			else if(that.have_show == "1"){ // 展示
				r_data.have_show = "1"
			}
			// 是否导出
			if(that.r_export == "1"){
				r_data.export = "1"
			}
			// 正常搜索
			if(that.r_export != "1"){
				console.log("r_data",r_data);
				JLpjList(r_data).then(res=>{
					console.log('搜索',res);
					
					// 因为批量操作的开启和暂停没有弹窗提示选了哪些内容，所以就不支持翻页也存着上一个页面存的内容
					// 每次请求重置批量选择的状态
					that.selectedData = []
					that.checkAll = false
					that.indeterminate = false
					that.r_export = ""
					
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						if(type == "export"){ // 表示导出
							that.$message.success(res.data.msg || "导出成功");
							that.search_button_loading = false
						}
						else {
							let data = res.data.data.data
							data.forEach(res=>{
								res.checked = false // 用于多选和单选
								res.popover_clicked = false // 表格-操作栏的气泡卡片
								if(res.opt_status == 'ENABLE'){
									res.status_checked = true
								}
								else { // 暂停
									res.status_checked = false
								}
							})
							
							that.search_button_loading = false
							
							that.$message.success('搜索成功');
							
							that.tableSumData = res.data.data.project_sum
							that.table_total = res.data.data.total
							that.tableShowData = data
						}
						// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
					else {
						
						that.search_button_loading = false
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
						// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
				})
				.catch(err=>{
					console.log("err",err);
					// 重置状态
					that.selectedData = []
					that.checkAll = false
					that.indeterminate = false
					
					that.search_button_loading = false
					that.r_export = ""
					
					that.$message.error('搜索失败，请检查网络状态')
					
					// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
					setTimeout(()=>{
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
					},300)
				})
			}
			else if(that.r_export == "1"){
				JLjhExport(r_data).then(res=>{
					console.log('导出',res);
					
					that.r_export = ""
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
						setTimeout(()=>{
							document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
						},300)
					}
				})
			}
			
		},
		// 导出
		exportButton(){
			this.r_export = "1"
			this.searchButton('export')
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 批量操作
		handleButtonClick(e) {
		    console.log('click left button', e);
		},
		plRequest(e){
			let that = this
			
			// 把相同adv_id的进行归类，分批次请求
			let arr = []
			this.selectedData.forEach(res=>{
				if(arr.length > 0){
					let ttt = true
					arr.forEach(res_z=>{
						if(res.adv_id == res_z){
							ttt = false
						}
					})
					if(ttt){
						arr.push(res.adv_id)
					}
				}
				else {
					arr.push(res.adv_id)
				}
			})
			console.log('this.selectedData',this.selectedData);
			let r_arrys = []
			arr.forEach(res=>{
				let obj = {
					o_adv_id: res,
					o_group_ids: []
				}
				this.selectedData.forEach(res_z=>{
					if(res_z.adv_id == res){
						obj.o_group_ids.push(res_z.id)
					}
				})	
				r_arrys.push(obj)
			})
			
			console.log('r_arrys',r_arrys);
			
			
				let r_opt_status
				
				if(e.key == '1'){ // 开启
					r_opt_status = "AD_STATUS_ENABLE"
				}
				else if(e.key == '2'){ // 暂停
					r_opt_status = "AD_STATUS_DISABLE"
				}
				else if(e.key == '3'){ // 删除
					r_opt_status = "AD_STATUS_DELETE"
				}
				
				let promise_arr = []
				for(let i = 0; i < r_arrys.length ; i ++){
					let ppp = new Promise((resolve,reject)=>{
						JLjhEditStatus({
							adv_id: r_arrys[i].o_adv_id,
							plan_ids: r_arrys[i].o_group_ids,
							opt_status: r_opt_status,
						}).then(res=>{
							console.log('开启/暂停/删除',res);
							if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){  // 8011表示内容为空
								resolve('OK')
							}
							else if(res.data.code === 401){ // 未登录
								reject('err')
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								reject('err')
								that.$message.error(`其他错误：${res.data.msg}`);
							}
						}).catch(err=>{
							reject('err')
						})
					})
					promise_arr.push(ppp)
				}
				// console.log("promise_arr",promise_arr)
				// 等待请求全部完成
				const result = Promise.all(promise_arr).then(res=>{
					// console.log('resultresult',res);
					that.search_button_loading = false
					
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					if(e.key == '1'){ // 开启
						that.$message.success('开启成功');
					}
					else if(e.key == '2'){ // 暂停
						that.$message.success('暂停成功');
					}
					else if(e.key == '3'){ // 删除
						that.dl_loading = false
						that.dl_modal = false
						that.$message.success('删除成功');
					}
					
					that.searchButton()
					
				}).catch(err=>{
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					that.checkAll = false
					that.indeterminate = false
					
					that.dl_loading = false
					
					that.search_button_loading = false
					that.$message.error('请求失败，请刷新页面再试')
				})
				console.log("result",result); 
			
		},
		// 批量操作按钮点击
		handleMenuClick(e) {
		    console.log('click', e);
			if(this.selectedData.length > 0){
				let that = this
				if(e.key == '1' || e.key == '2'){ // 开启
					that.search_button_loading = true
					
					// console.log(this.selectedData);
					that.plRequest(e)
				}
				
				else if(e.key == '3'){ // 删除
					this.dl_modal = true
				}
				
			}
			else {
				this.$message.warning('还没有选择内容');
			}
			
		},
		// 全部/只看消耗/只看显示
		handleMenuClickB(e){
			
			if(e.key != this.type_button_key){ // 避免重复点击
				console.log(e);
				if(e.key == '1'){ // 全部
					this.have_cost = "", // 消耗
					this.have_show = "", // 展示
					this.type_button_key = e.key
					this.type_button_text = "全部"
					this.searchButton()
				}
				else if(e.key == '2'){ // 消耗
					this.have_cost = "1", // 消耗
					this.have_show = "", // 展示
					this.type_button_key = e.key
					this.type_button_text = "只看有消耗"
					this.searchButton()
				}
				else if(e.key == '3'){ // 展示
					this.have_cost = "", // 消耗
					this.have_show = "1", // 展示
					this.type_button_key = e.key
					this.type_button_text = "只看有展示"
					this.searchButton()
				}
			}
		},
		// 开启、暂停按钮点击
		statusCheckbox(e,item){
			console.log('qqq',e,item);
			// item.status_checked = e
			this.selectedData.push(item)
			if(item.opt_status == 'ENABLE'){ 
				console.log('启用');
				this.plRequest({key: "2"}) // 当前为开启状态就要改为暂停状态
			}
			else { // 暂停
				console.log('暂停');
				this.plRequest({key: "1"}) // 当前为暂停状态就要改为开启状态
			}
			
		},
		
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			// console.log(that.r_sort_field);
			// console.log(that.r_sort_type);
			that.r_page = 1
			that.searchButton()
		},
		
		
		// 批量删除确认
		dlOk(){
			let that = this
			
			that.dl_loading = true
			that.plRequest({key:"3"})
		},
		// 删除弹窗取消
		dlCancel(){
			if(this.dl_loading){
				return
			}
			
			this.dl_modal = false
		},
		
		
		// 自定义列
		// 数据项————————
		onChangeSJ(e,index,d_tem){
			this.rableTitle[index].show_control = e.target.checked
			console.log(`checked = ${e.target.checked} + ${index}`);
			// 重新计算表格宽度
			this.computeTableWidth()
			
			// 检测子项是否都选中，子项全部选中，则父项也要跟着选中。子项有一个没有被勾选，则父项也要取消勾选
			let ccccc = true
			d_tem.showTitle.forEach(res=>{
				this.rableTitle.forEach(t_es=>{
					if(res == t_es.type && !t_es.show_control){ // 表示有勾选
						ccccc = false
					}
				})
			})
			d_tem.custom_checkbox = ccccc
		},
		// 自定义列的小标题前的选择框
		checkboxCustom(e,d_tem){
			d_tem.custom_checkbox = e.target.checked
			
			this.rableTitle.forEach(res=>{
				d_tem.showTitle.forEach(d_es=>{
					if(res.type == d_es){
						if(e.target.checked){ // 要进行选中
							res.show_control = true
						}
						else {
							res.show_control = false
						}
					}
				})
			})
			// 重新计算表格宽度
			this.computeTableWidth()
		},
		// 自定义列弹窗确认按钮
		customTd(){
			let s_data = []
			this.rableTitle.forEach(res=>{
				let obj = {
					type: res.type,
					show_control: res.show_control
				}
				s_data.push(obj)
			})
			localStorage.setItem("table_custtom_JLproject",JSON.stringify(s_data));
			this.custtom_visible = false
		},
		// 计算表格宽度
		computeTableWidth(){
			let that = this
			let ttt = JSON.parse(JSON.stringify(that.rableTitle))
			
			// 获取表格信息
			let table_info = this.$getTableInfo(ttt, 60)
			that.body_width = table_info.body_width
			that.table_scroll_width = table_info.table_width
			that.table_null_width = table_info.null_width
			
			that.$nextTick(()=>{
				// 给母页面的tab传递粘性定位用的参数
				that.$bus.$emit("stickyData", that.table_scroll_width);
			})
			
		},
	},
	filters: {
		dayToFixed(e){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",e)
			if(Object.keys(e).length > 0){
				let v = (Number(e.charge_money)/Number(e.cost))*1.06*100
				return v.toFixed(2)
			}
			else {
				return '-'
			}
			
		}
	}
}
</script>

<style scoped>
.day-data-a {
	font-size: 16px;
	font-weight: 800;
}
.day-data-b {
	font-size: 13px;
}
.day-data-c {
	font-size: 13px;
	margin-top: 5px;
}
.day-data-e {
	display: flex;
	align-items: flex-end;
}

/* 侧边栏样式 */
.form-cell-box {
	margin-bottom: 20px;
}
.class-title {
	width: 115px;
}

.custom-title {
	font-size: 15px;
	font-weight: 600;
	margin-bottom: 10px;
}
.custom-cell-box {
	display:flex;
	flex-wrap: wrap;
	padding-left: 20px;
	margin-bottom:20px;
}
</style>